import { render, staticRenderFns } from "./globalMainSearch.vue?vue&type=template&id=f858473c&scoped=true&"
import script from "./globalMainSearch.vue?vue&type=script&lang=js&"
export * from "./globalMainSearch.vue?vue&type=script&lang=js&"
import style0 from "./globalMainSearch.vue?vue&type=style&index=0&id=f858473c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f858473c",
  null
  
)

export default component.exports